<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Accueil DRH" v-if="messageAccueil">
       
        <div v-html="messageAccueil"></div>
      </BaseBlock>
    </v-col>

    <div v-if="processusBool">
      <Tuiles :processusKeys="processusKeys" :processus="processus"></Tuiles>
    </div>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import Tuiles from "@/components/Tuiles";
import ApiRefMessageRepository from "@/repositories/ApiRefMessageRepository";
import ApiProcessusRepository from "@/repositories/ApiProcessusRepository";

export default {
  name: "HomeDRH",
  components: { BaseBlock, Tuiles },
  data() {
    return {
      messageAccueil: null,
      processus: null,
      processusCount: null,
      processusKeys: null,
      processusBool: false
    };
  },
  async mounted() {
    this.messageAccueil = await ApiRefMessageRepository.getMessageAccueilDRH();
    if(this.$store.state.user != null)
    {
    this.processus = await ApiProcessusRepository.getAllDRHinMap();
    this.processusKeys = Object.keys(this.processus);
    this.processusCount = await ApiProcessusRepository.getAllCount();
    this.addCount();
    }
  },
  methods: 
  {
        addCount()
    {
      for(var i of this.processusKeys)
      { 
        for(var e of this.processus[i]) {
          const processusCountKeys = Object.keys(this.processusCount);
          for(var a of processusCountKeys)
          {
            if(e.id == a)
            {
              e.count = this.processusCount[a];
            }
          }
        }
      }
      this.processusBool = true;
      
    }
  },
};
</script>